import cpSite from './cpSite'

/**
 * Работа с IE
 */
const isIE = {
  state: {
    isActive: false
  },
  integrate: function () {
    if (cpSite.config.DEVMODE) {
      console.log('integrate: isIE')
    }

    if (false || !!document.documentMode) {
      // console.log('active: isIE')
      document.write('<script src="/static/libs/polyfill/css-vars-ponyfill.js"></script>')
      document.addEventListener('DOMContentLoaded', function () {
        window.cssVars()
      })
      cpSite.isIE = true
    } else {
      // console.log('active: isNOTIE')
      cpSite.isIE = false
    }

    // Запись об активации скрипта
    this.state.isActive = true
  }
}

export default isIE
